module.exports = __webpack_public_path__ + "static/img/face.bba1781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/face.png
// module id = pnjB
// module chunks = 1